import { useCallback } from "react";
import { deleteSavedSearch } from "../../../api/searchApi";
import { deleteWorkspaceApi } from "../../../api/workspaceApi";
import Defaults from "../../../helper/defaults";
import { removePinnedSavedSearchId } from "../../../helper/pinnedSavedSearches";
import { deleteMockSavedSearch, isMockSavedSearchId } from "../../../fixture/mockSavedSearches";

function useSavedSearchDelete({
    setItemToDelete, setDeleteDialogOpen, itemToDelete, setIsDeleting,
    savedSearchCatalog, setSavedSearchChoices, setPinnedIds, selectedSavedSearch,
    setTermsInclude, setTermsExclude, setIndustryInclude, setIndustryExclude,
    setLocations, setRevenueLowerBound, setRevenueUpperBound, setEmployeesLowerBound,
    setEmployeesUpperBound, setNaturalQuery, onHydrateFilters, setSelectedSavedSearch,
    onSavedSearchBaselineChange, onClear
}) {
const initiateDelete = useCallback((event, option) => {
    event?.stopPropagation?.();
    setItemToDelete(option);
    setDeleteDialogOpen(true);
  }, [setDeleteDialogOpen, setItemToDelete]);

const confirmDelete = useCallback(async () => {
    const deleteId = itemToDelete?._id || itemToDelete?.id;
    if (!deleteId) return;
    setIsDeleting(true);
    try {
      if (savedSearchCatalog === "workspace") {
        if (isMockSavedSearchId(deleteId)) {
          deleteMockSavedSearch(deleteId);
        } else {
          const res = await deleteWorkspaceApi(deleteId);
          if (!(res && (res.status === 200 || res.status === 204))) {
            console.error("Failed to delete saved search workspace:", res);
            return;
          }
        }
      } else {
        await deleteSavedSearch(deleteId);
      }
      setSavedSearchChoices((prev) =>
        prev.filter((search) => (search._id || search.id) !== deleteId)
      );
      setPinnedIds(removePinnedSavedSearchId(deleteId));
      const wasActive =
        (selectedSavedSearch?._id || selectedSavedSearch?.id) === deleteId;
      if (wasActive) {
        setTermsInclude([]);
        setTermsExclude([]);
        setIndustryInclude([]);
        setIndustryExclude([]);
        setLocations([]);
        setRevenueLowerBound(Defaults.search.revenueLowerBound);
        setRevenueUpperBound(Defaults.search.revenueUpperBound);
        setEmployeesLowerBound(Defaults.search.employeesLowerBound);
        setEmployeesUpperBound(Defaults.search.employeesUpperBound);
        setNaturalQuery("");
        onHydrateFilters?.({});
        setSelectedSavedSearch(null);
        onSavedSearchBaselineChange?.(null);
        onClear?.();
      }
      setDeleteDialogOpen(false);
      setItemToDelete(null);
    } catch (error) {
      console.error("Failed to delete search:", error);
    } finally {
      setIsDeleting(false);
    }
  }, [itemToDelete?._id, itemToDelete?.id, setIsDeleting, savedSearchCatalog, setSavedSearchChoices, setPinnedIds, selectedSavedSearch?._id, selectedSavedSearch?.id, setDeleteDialogOpen, setItemToDelete, setTermsInclude, setTermsExclude, setIndustryInclude, setIndustryExclude, setLocations, setRevenueLowerBound, setRevenueUpperBound, setEmployeesLowerBound, setEmployeesUpperBound, setNaturalQuery, onHydrateFilters, setSelectedSavedSearch, onSavedSearchBaselineChange, onClear]);

return {
    initiateDelete, confirmDelete
};
}

export { useSavedSearchDelete };
